// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3153q","choiceBoxes":"toolbarselects_choiceBoxes__2TApP","simpleField":"toolbarselects_simpleField__2SYEF"};